import React from "react"
import { Seo } from "../components"
import {
  LatestDevelopment,
  LatestBlog,
  Packages,
  Reviews,
  Contact,
  Hero,
  Usp,
} from "../components/page/home"

import { FormProvider } from "../contexts"

export default function Index() {
  return (
    <FormProvider>
      <Seo title="Home" />
      <Hero />
      <Usp />
      <LatestDevelopment />
      <Packages />
      <LatestBlog />
      <Reviews />
      <Contact />
    </FormProvider>
  )
}
